module.exports = __webpack_public_path__ + "img/picture_ksdgfz03.160dc178.png";